module.exports = __webpack_public_path__ + "static/img/bc_qt_3.3870a237.png";